import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { dbnpRegistries } from '../../../../../../redux/dbnp-registries/action';
import { selectDbnpRegistriesQueryItems } from '../../../../../../redux/dbnp-registries/selector';
import { dbnp } from '../../../../../../redux/dbnp/action';
import { opennetworkDomains } from '../../../../../../redux/opennetwork-domains/action';
import { selectDbnpListItems } from '../../../../../../redux/dbnp/selector';
import { selectOpennetworkDomainsListItems } from '../../../../../../redux/opennetwork-domains/selector';
import storePersist from '../../../../../../redux/storePersist';
import DBNRegistryDetails from '../components/dbnp-registry-details';
import { orgRegistries } from '../../../../../../redux/org-registries/action';

const DbnpRegistry = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const dbnpRegistriesQuery = useSelector(selectDbnpRegistriesQueryItems)
    const dpnpNameLists = useSelector(selectDbnpListItems)
    const openNetworkDomainNameLists = useSelector(selectOpennetworkDomainsListItems)
    const librariesItems = storePersist?.get("library")?.current;
    const countries =  storePersist.get('countries').current?.items;
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [ selectedDbnpRegistry, setSelectedDbnpRegistry ] = useState<any>({})

    const fetchDbnpRegistryById = () => {
        setIsLoading(true)
        dispatch(dbnpRegistries.query({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries/query`, 
            entity: 'dbnpRegistries', 
            jsonData: {
                Records: [
                    {
                        DBNPRegistryId: parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
            setIsLoading(false)
        })
    }

    const handleBacicInnerFormChange: any = (event: any, field: string) => {
        setSelectedDbnpRegistry({ ...selectedDbnpRegistry, [field]: event });
    }
    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
          '.',
          field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedDbnpRegistry({ ...selectedDbnpRegistry, [fields[0]]: value });
    }

    useEffect(
        () => {
            dispatch(dbnp.list({ 
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp/list`, 
                entity: 'dbnp', 
                jsonData: {} 
            })).then(() => {
                dispatch(opennetworkDomains.list({ 
                    url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`, 
                    entity: 'opennetworkDomains', 
                    jsonData: { "Context": {},
                    "Records": [
                        {
                            "IsSubDomain": null 
                        }
                    ],
                    "Pagination": {
                      // "PageNumber": pageData,
                      // "PageSize": pageSize,
                      "SortField": "GlobalDBNDomainId",
                      "SortOrder": "desc",
                    }} 
                }))
            }).then(() => {
                if (parmas?.id > 0) {
                    fetchDbnpRegistryById()
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            })
        },
        []
    )

    const parentDomain = openNetworkDomainNameLists?.result?.items.filter(
        (subDomainData: any) => subDomainData.IsSubDomain === false
    )
    const subDomains = openNetworkDomainNameLists?.result?.items.filter(
        (subDomainData: any) => subDomainData.IsSubDomain === true
    )

    useEffect(
        () => {
            if (isQuery) {
                setSelectedDbnpRegistry(dbnpRegistriesQuery?.result?.items)
            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(dbnpRegistries.resetAction({ actionType: 'update' }))
            await dispatch(dbnpRegistries.update({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries`, 
                entity: 'dbnpRegistries', 
                jsonData: {
                    Records: [
                        selectedDbnpRegistry
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(dbnpRegistries.resetAction({ actionType: 'create' }))
            await dispatch(dbnpRegistries.create({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries`, 
                entity: 'dbnpRegistries', 
                jsonData: {
                    Records: [
                        selectedDbnpRegistry
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/management/organization/dbn/dbnp-registries')
    }

    const handlePopulateOrgRegistry = async () => {
        await dispatch(orgRegistries.resetAction({ actionType: 'create' }))
        await dispatch(orgRegistries.create({
          url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/org-registries/publish`,
          entity: 'orgRegistries',
          jsonData: {
            Context: {},
            Records: [{}]
          }
        })).then(() => {
          back()
        });
      }
    return (
        <>
            {isLoading ? <PageLoader /> :
                <DBNRegistryDetails
                    handleInnerFormChange={handleInnerFormChange}
                    handleBacicInnerFormChange={handleBacicInnerFormChange}
                    selectedDbnpRegistry={selectedDbnpRegistry}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    id={parmas?.id}
                    dbnpname={dpnpNameLists?.result?.items}
                    opsnumber={librariesItems?.Ops_no}
                    domains={parentDomain}
                    subDomains={subDomains}
                    countries={countries}
                    handlePopulateOrgRegistry={handlePopulateOrgRegistry}
                />
            }
        </>
    )

}

export default DbnpRegistry;